export { Heading, TextAttr, AdvancedImageAttr, ImageAttr } from "../blocks/attributes";
export { BlockArea } from "../blocks/BlockArea";
export { ModuleAttribute } from "../blocks/ModuleAttribute";
export { ModuleHeaderAction } from "./ModuleHeaderAction";
export { Icon } from "../blocks/Icon";
export { useAttr, useBlock } from "../blocks/context";
export { useT, useContentLocale } from "../admin-i18n";
export { confirmDialog, noticeDialog, promptDialog } from "../editor/dialogs";
export { lv, localeHref } from "../i18n";
export type { Localized, MediaItem } from "../types";
export type { ImageValue, VideoValue } from "../media-shared";
export type { BlockCtx } from "../blocks/context";
export type { ModuleAttributeIntegration } from "../blocks/ModuleAttribute";
export type { ImageAttrProps } from "../blocks/attributes.types";
export type { AdvancedImageAttrProps } from "../blocks/AdvancedImageAttr";
/** Cookie consent for third-party scripts and embeds (CMS API 1.9.0, docs/cookie-consent-plan.md §4.3). */
export { useConsent, ConsentGate, ConsentEmbed, CookieSettingsLink, loadScript, onConsentChange, openConsentPreferences, grantService } from "../consent/client/api";
